import React from 'react';

interface Props {
    title: string;
    onClick: () => void;
    active: boolean;
    disabled?: boolean;
}

const PickUpDateItemDrawer = ({title, onClick, active, disabled}: Props) => {
	return (
        <button className={`btn btn-default ${active ? 'selected': ''}`} onClick={onClick} title={title} disabled={disabled}>
            {title}
        </button>
	)
}

export default PickUpDateItemDrawer;